import React from 'react';
import { Typography } from 'amphitheatre';

import UpdatePage from '../UpdatePage';

import Saber from './_img_saber_logo.png';

const { Paragraph } = Typography;

const Update1: React.FunctionComponent = () => {
  return (
    <UpdatePage title="Welcome">
      <Paragraph>
        Welcome to the inaugural Quest competition, which we’re kicking off with
        the Quest For Blue.
      </Paragraph>
      <Paragraph>
        The idea is simple— you get a hypothetical US$10M investment to solve a
        space mission problem of your choice. You come up with the idea. You
        come up with the solution. Then you communicate that solution to us.
      </Paragraph>
      <Paragraph>
        But this is deceptively simple. How many satellites and how many ground
        stations do you buy? How high an altitude is reasonable? What do you
        charge your customers? How do you get the most products to the ground?
        Are there interesting orbits to get the most value to your customers?
        The choice is yours and there are many options.
      </Paragraph>
      <Paragraph>
        Throughout the challenge, you will get templates and other training
        materials to help you along the way. At the end of the challenge your
        submission will have only three files for us to review— a 2-3 page
        summary of your concept, the software output files, and an Excel
        spreadsheet.
      </Paragraph>
      <Paragraph>
        Saber is providing a 30 day subscription to our mission planning
        P.I.G.I. software to help you along. We’re also providing some tutorials
        and templates to get you started.
      </Paragraph>
      <Paragraph>
        Navigate along the tabs up the top to explore the website and watch the
        tutorial for more info on P.I.G.I. We also have written information to
        help you along if you prefer a more static learning experience. Also get
        to know each other on the
        <a href="https://www.facebook.com/groups/questforblue">
          competition Facebook page,
        </a>
        share tips, and ask questions. We’re happy to help you along the way.
      </Paragraph>
      <Paragraph>Good luck!</Paragraph>
      <Paragraph>
        <img src={Saber} alt="signature" height="64px" />
      </Paragraph>
      <Paragraph>Saber Astronautics Team</Paragraph>
    </UpdatePage>
  );
};

export default Update1;
